import React from 'react'
import { Button, Modal } from 'antd'
import './index.less'
import { ReactComponent as Paid } from '@/assets/icons/paid.svg'
import { useDispatch, useSelector } from 'react-redux'
import action from '../../../action'
import { requsetGetSubscription } from '@/api/apis'
import sentGaEvent from '../../../ga/index'
import Utils from '../../../utils/utils'
import { useTranslation } from 'react-i18next'
const PayBill = () => {
  const { t } = useTranslation(['common'])
  const reducerData = useSelector(state => state.common)
  const workData = useSelector(state => state.work)
  const dispatch = useDispatch()
  const { payBill, purchaseModalObj } = reducerData
  const { work } = workData

  //"uploadSizeBiggerThanLimit" 上传大文件
  const onPayment = () => {
    // console.log('reducerData', reducerData);

    dispatch(
      action.onPayBill({
        visible: false,
        type: ''
      })
    )
    requsetGetSubscription()
      .then(res => {
        if (res.code === 200) {

          payResultCheck(res.data.subscription)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }
  const computeTime = (subTime: string, nowTime: string) => {
    let time1 = new Date(subTime.substring(11, subTime.length)).getTime()
    let time2 = new Date(nowTime.substring(11, nowTime.length)).getTime()
    if (time1 - time2 > 0) {
      //如果订阅时间大于本地存的时间，说明续费，否则退订或者没买
      return true
    } else {
      return false
    }
  }
  const payResultCheck = subscriptionStatus => {
    let workPlace
    let purchaseType = ''
    if (work === 'cut') {
      workPlace = 'ToolsCutter'
      if (purchaseModalObj?.type === 'uploadSizeBiggerThanLimit') {
        purchaseType = 'ToolsCutterSizeExceed20M'
      } else {
        purchaseType = 'ToolsCutter6TrialOver'
      }
    } else if (work === 'removeWatermark') {
      workPlace = 'ToolsWR'
      if (purchaseModalObj?.type === 'uploadSizeBiggerThanLimit') {
        purchaseType = 'ToolsWRSizeExceed20M'
      } else {
        purchaseType = 'ToolsWR6TrialOver'
      }
    } else if (work === 'addMusic') {
      workPlace = 'AddMusic2Video'
      if (purchaseModalObj?.type === 'uploadSizeBiggerThanLimit') {
        purchaseType = 'AddMusic2VideoSizeExceed20M'
      } else {
        purchaseType = 'AddMusic2Video6TrialOver'
      }
    } else if (work === 'speed') {
      workPlace = 'ToolsSpeed'
      if (purchaseModalObj?.type === 'uploadSizeBiggerThanLimit') {
        purchaseType = 'ToolsSpeedSizeExceed20M'
      } else {
        purchaseType = 'ToolsSpeed6TrialOver'
      }
    } else if (work === 'reverse') {
      workPlace = 'ToolsReverse'
      if (purchaseModalObj?.type === 'uploadSizeBiggerThanLimit') {
        purchaseType = 'ToolsReverseSizeExceed20M'
      } else {
        purchaseType = 'ToolsReverse6TrialOver'
      }
    } else if (work === 'addWatermark') {
      workPlace = 'ToolsAddWatermark'
      if (purchaseModalObj?.type === 'uploadSizeBiggerThanLimit') {
        purchaseType = 'ToolsAddWatermarkSizeExceed20M'
      } else {
        purchaseType = 'ToolsAddWatermark6TrialOver'
      }
    }

    let productName = 'OLPro'
    let sku = payBill.type === 'month' ? 'Monthly' : 'yearly'
    let systemType = Utils.getSystemType()

    let label = `${workPlace}_${purchaseType}_${productName}_${sku}_${systemType}`
    const { subscription } = reducerData
    if (!subscriptionStatus) {
      sentGaEvent({
        category: 'OrderStatus',
        action: 'OrderFail',
        label: label
      })
    } else {
      let { status, active_Time } = subscriptionStatus[0]
      if (subscription === 'isUnSubscription' && status === 'Active') {
        sentGaEvent({
          category: 'OrderStatus',
          action: 'OrderSuccess',
          label: label
        })
      }
      if (subscription.status === 'Expired' && status === 'Active') {
        sentGaEvent({
          category: 'OrderStatus',
          action: 'OrderSuccess',
          label: label
        })
      }
      if (status === 'Expired') {
        console.log('埋点执行')
        sentGaEvent({
          category: 'OrderStatus',
          action: 'OrderFail',
          label: label
        })
      }
      if (subscription.status === 'Active' && status === 'Active') {
        if (subscription.active_Time === active_Time) {
          //未续费
          sentGaEvent({
            category: 'OrderStatus',
            action: 'OrderFail',
            label: label
          })
        } else {
          if (computeTime(active_Time, subscription.active_Time)) {
            // 新增订阅
            sentGaEvent({
              category: 'OrderStatus',
              action: 'OrderSuccess',
              label: label
            })
          } else {
            // 订阅后退订
            sentGaEvent({
              category: 'OrderStatus',
              action: 'OrderFail',
              label: label
            })
          }
        }
      }
    }
    dispatch(action.onSubscriptionChange(subscriptionStatus !== null ? subscriptionStatus[0] : null))
  }
  return (
    <Modal
      className="payBill"
      centered
      footer={null}
      maskClosable={false}
      visible={payBill.visible}
      onCancel={() => onPayment()}
      closable={false}
    >
      <div>
        <div className="billTitle">{t('payBill')}</div>
        <div className="billIcon">
          <Paid />
        </div>
        <div className="bottomBtn">
          <Button onClick={() => onPayment()} className="notYet" type="default">
            {t('Not yet')}
          </Button>
          <Button onClick={() => onPayment()} className="complete" type="default">
            {t('Payment completed')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default PayBill
